import { useState, useEffect } from 'react';
import './EffluentDisposal.css';
import EffluentDisposal from './EffluentDisposal';
import 'react-toastify/dist/ReactToastify.css';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";

const EffluentDisposalRisk = ({ handleWizardChanged, handleWizardChangedBack, handleMoveToNextPage }) => {

    const [effluentDisposal, setEffluentDisposal] = useState({
        Section: 'EffluentDisposalRisk', SectionName: 'EffluentDisposal', IsMapOnly: false, IsMapRisk: false
    });

    useEffect(() => {
        OnPageload();
    }, [])
    const OnPageload = async (e) => {

    }

    return (
        <div>
            <EffluentDisposal handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} handleMoveToNextPage={handleMoveToNextPage} pageSection={effluentDisposal} ></EffluentDisposal>
        </div>
    )
}
export default EffluentDisposalRisk;